import React from 'react'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import Line from '../../../../../components/pdf/Line'

const Conclusion = () => {
  return (
    <View pageBreakAfter>
      <Separator weight={1} />

      <Line height={3} color="#333" />

      <Text size={30} bold>
        Conclusão
      </Text>

      <Separator weight={5} />

      <Text bold size={18}>
        ENCERRAMENTO
      </Text>

      <Separator weight={5} />

      <Text>
        Esta avaliação ergonômica do trabalho traz a descrição das atividades executadas pelos trabalhadores, bem como
        as características do posto de trabalho. Apresenta, ainda, a identificação dos riscos ergonômicos.
      </Text>

      <Separator weight={5} />

      <Text>
        As recomendações do relatório seguem o princípio da correção/adequação dos pontos críticos e devem ser
        analisadas quanto a sua viabilidade, e substituídas caso necessário. Os benefícios da implementação de melhorias
        ergonômicas estão diretamente ligados ao bem-estar dos usuários, bem como a possíveis ganhos de produtividade e
        qualidade do produto, de vida para o trabalhador e para reduzir os riscos ocupacionais.
      </Text>

      <Separator weight={5} />

      <Text>
        Esta Análise Ergonômica do Trabalho contém 48 páginas mais anexos, devidamente numeradas, sendo esta, assinada
        pelo executante.
      </Text>

      <Separator weight={5} />

      <Text>
        Validade da Análise Ergonômica do Trabalho: 01 DE MAIO DE 2026, ou até haver qualquer alteração no modo
        operatório, atividades/tarefas, layout ou ambiente dos colaboradores, sendo necessária reavaliação dos riscos
        ergonômicos existentes.
      </Text>

      <Separator weight={40} />

      <Line height={1} width={'50%'} align={'center'} color="#333" />

      <Separator weight={2} />

      <Text align={'center'}>Celina de Andrade Marques Gil</Text>
      <Text align={'center'}>Fisioterapeuta - Crefito-3/20349-F</Text>
      <Text align={'center'}>Consultora em Ergonomia</Text>

      <Separator weight={20} />
    </View>
  )
}

export default Conclusion
